import usePolling from './usePolling';

/**
 * This function checks if VWO is loaded in the global scope.
 * @returns
 */
const isVWOExpDefined = async () => {
  // This is a global variable set by VWO, so we can check if VWO is loaded
  // @ts-ignore
  if (typeof window._vwo_exp === 'undefined') {
    throw new Error('VWO not loaded');
  }

  return true;
};

/**
 * Check if the variation of the VWO experiment is enabled.
 * @param featureID
 * @returns
 */
const isFeatureEnabledByVWO = async (featureID: string) => {
  // @ts-ignore
  // this is being set by VWO A/B test Experiment in the global scope
  const flagValue = window?.EXPERIMENTS?.[featureID];

  if (typeof flagValue === 'boolean') {
    return flagValue;
  }

  return false;
};

export const useIsVWOReady = () =>
  usePolling({
    id: 'vwo',
    query: () => isVWOExpDefined(),
    retryInterval: 100, // in milliseconds
    retry: 200, // 200 attempts * 100ms = 20 seconds of polling
  });

/**
 * This hook check if the cart redesign feature flag is enabled by VWO.
 * It will poll the EXPERIMENTS global variable to check if the flag is enabled.
 */
export const useIsFeaturedEnabledByVWO = (featureID: string) =>
  usePolling({
    id: ['vwo-feature-', featureID],
    query: () => isFeatureEnabledByVWO(featureID),
    retry: 10,
    retryInterval: 100, // in milliseconds
  });

export default useIsVWOReady;
